import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useMenuCollapsedState } from '../../../hooks'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'

import * as styles from './LayoutHeaderSearchButton.module.css'

import CloseIcon from '../../../icons/close.svg'
import SearchIcon from '../../../icons/search.svg'

function LayoutHeaderSearchButton({
  className = styles.LayoutHeaderSearchButton,
  isOpenSearch,
  onSetOpenSearch,
  ...buttonProps
}) {
  const { t } = useTranslation()

  const [collapsed, setCollapsed] = useMenuCollapsedState()

  function handleClick() {
    if (!collapsed) {
      setCollapsed(true)
    }

    onSetOpenSearch(!isOpenSearch)
  }

  const tooltipKey = isOpenSearch
    ? 'Header.SearchCloseButtonKey'
    : 'Header.SearchButtonKey'

  return (
    <div>
      <Button.Flat
        {...buttonProps}
        isGrey
        beforeIconProps={{ Icon: isOpenSearch ? CloseIcon : SearchIcon }}
        className={className}
        height={BUTTON_HEIGHT_32}
        tooltip={t(tooltipKey)}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.bottom}
        onClick={handleClick}
      />
    </div>
  )
}

export default LayoutHeaderSearchButton
